module.exports = __webpack_public_path__ + "media/images/icons/mapaKriminatlity-41ba3ad2af35fd4732cc0c29afc49fa9.svg";